export enum RuleFilterOperatorsType {
  in = "in",
  nin = "nin",
  eq = "eq",
  gt = "gt",
  gte = "gte",
  lt = "lt",
  lte = "lte",
  ne = "ne"
}
